import React from "react"

function NotFound() {
  // TODO implement
  return (
    <div id="v-buddy-notfound">
      <h1>Buddy 404</h1>
    </div>
  )
}

export default NotFound